import { Model } from '@vuex-orm/core';
import Building from '@/models/Building';
import Residence from '@/models/Residence';

export default class Availability extends Model {
  static entity = 'availabilities';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      showCalculator: this.boolean(false),
      showContactForm: this.boolean(false),
      showPrice: this.boolean(false),
      showLinks: this.boolean(false),
      showFiles: this.boolean(false),

      // relationships
      buildings: this.hasMany(Building, 'availability_id'),
      residences: this.hasMany(Residence, 'availability_id'),
    };
  }

  static transformer(data) {
    const availabilities = [];
    data.data.forEach(item => {
      const availability = {};
      availability.id = item.id;
      availability.name = item.name;
      availability.slug = item.slug;
      availability.count = item.count;
      availability.description = item.description;
      availability.showCalculator = item.acf.calculator;
      availability.showContactForm = item.acf.contactForm;
      availability.showPrice = item.acf.showPrice;
      availability.showLinks = item.acf.showLinks;
      availability.showFiles = item.acf.showFiles;
      availabilities.push(availability);
    });
    return availabilities;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/salesstatus?per_page=25';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
